/*
 * Copyright (c) 2019 by Filestack.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export type RawFile = Blob | Buffer | File | string;
export type NamedInputFile = {
  name?: string;
  file: RawFile;
};

export type InputFile = RawFile | NamedInputFile;

export const base64Regexp = /data:([a-zA-Z]*\/[a-zA-Z+]*);base64,([^\"]*)/i;

/**
 * Check if file is blob
 * @param input
 */
export const isFileBlob = (input: InputFile): input is Blob => input.toString() === '[object Blob]';

/**
 * Check if file is instance of named interface
 *
 * @param input
 */
export const isFileNamed = (input: InputFile): input is NamedInputFile => input && input['file'] && input['name'];

export * from './file_tools.node';
